import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { plansActions } from "../../../reducers/plans";
import { policesActions } from "../../../reducers/polices";
import { APIPlans } from "../../../api";
import { useAuthContext } from "../../../context";
import { SERVICE_API_URLS, ServiceAPI } from "../../../api/service";

interface IProps {
  children?: React.ReactNode;
}

const AppState = ({ children }: IProps): React.ReactElement => {
  const dispatch = useDispatch();
  const { token } = useAuthContext();

  const { isError, error } = useQuery({
    retry: false,
    queryKey: [SERVICE_API_URLS.getPolicesOptions],
    queryFn: async () => {
      dispatch(policesActions.fetchPolicesRequest());
      const response = await ServiceAPI.getPolicesOptionsRequest();
      dispatch(policesActions.fetchPolicesSuccess(response.data));
      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      dispatch(policesActions.fetchPolicesFailed());
      console.error("error fetching getPolicesOptionsRequest", error);
    }
  }, [isError, error]);

  useEffect(() => {
    (async () => {
      try {
        if (token) {
          dispatch(plansActions.fetchRequest());
          const { data } = await APIPlans.getPlansListRequest();
          dispatch(plansActions.fetchSuccess(data));
        }
      } catch (error) {
        console.error("error fetching plans list:", error);
        dispatch(plansActions.fetchFailed());
      }
    })();
  }, [token]);

  return <>{children}</>;
};

export default AppState;
